var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    d: "M18.7129 25.7366H3.21251C2.52458 25.7366 1.96716 26.3144 1.96716 27.0269V78.6212C1.96716 79.334 2.52458 79.9115 3.21251 79.9115H18.7129C19.4008 79.9115 19.9583 79.334 19.9583 78.6212V27.0269C19.9583 26.3144 19.4008 25.7366 18.7129 25.7366Z",
    fill: "#262523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "M10.9683 0.0878906C5.32836 0.0878906 0.73999 4.83679 0.73999 10.674C0.73999 16.5137 5.32836 21.2644 10.9683 21.2644C16.6038 21.2644 21.1884 16.5134 21.1884 10.674C21.1887 4.83679 16.6038 0.0878906 10.9683 0.0878906Z",
    fill: "#262523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "M58.1392 24.4543C51.9137 24.4543 47.3117 27.2272 44.5203 30.378V27.027C44.5203 26.3145 43.9629 25.7367 43.275 25.7367H28.4307C27.7427 25.7367 27.1853 26.3145 27.1853 27.027V78.6213C27.1853 79.3341 27.7427 79.9116 28.4307 79.9116H43.8972C44.5851 79.9116 45.1425 79.3341 45.1425 78.6213V53.0941C45.1425 44.492 47.3976 41.1408 53.185 41.1408C59.488 41.1408 59.9888 46.5132 59.9888 53.5367V78.6216C59.9888 79.3343 60.5463 79.9119 61.2342 79.9119H76.7064C77.3944 79.9119 77.9518 79.3343 77.9518 78.6216V50.3212C77.9518 37.5302 75.5978 24.4543 58.1392 24.4543Z",
    fill: "#262523"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedind);
export default __webpack_public_path__ + "static/media/linkedind.61d9ef71c480a1f18ffbdb64a22f2d14.svg";
export { ForwardRef as ReactComponent };